<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue'

import { FlexComponent, TagComponent } from '@/ui-library'

const props = defineProps<{ tags: { content: string; id: string | number }[] }>()

const containerRef = ref<HTMLElement | null>(null)
const tagRefs = ref<HTMLElement[]>([])
const visibleTags = ref(props.tags)
const visibleCount = ref<number>(props.tags.length)

function calculateVisibleTags(data: HTMLElement) {
  const containerWidth = data.clientWidth
  let usedWidth = 0
  let count = 0

  for (let i = 0; i < props.tags.length; i++) {
    const tagEl = tagRefs.value[i]
    if (!tagEl) {
      continue
    }

    const tagWidth = tagEl.offsetWidth + 4
    if (usedWidth + tagWidth <= containerWidth) {
      usedWidth += tagWidth
      count++
    } else {
      break
    }
  }

  visibleCount.value = count
  visibleTags.value = props.tags.slice(0, count)
}

onMounted(async () => {
  if (containerRef.value) {
    await nextTick(() => containerRef.value && calculateVisibleTags(containerRef.value))
  }
})
</script>
<template>
  <div ref="containerRef" class="tags-container">
    <div v-for="tag in visibleTags" :key="tag.id" ref="tagRefs">
      <TagComponent size="small">{{ tag.content }}</TagComponent>
    </div>
    <div class="hidden-tags">
      <TagComponent v-if="props.tags.length > visibleCount" size="small"> +{{ props.tags.length - visibleCount }} </TagComponent>
      <FlexComponent direction="column" :gap="4" class="hidden-tags__list">
        <TagComponent v-for="tag in props.tags.slice(visibleCount)" :key="tag.id" size="small">{{ tag.content }}</TagComponent>
      </FlexComponent>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tags-container {
  display: flex;
  flex-wrap: nowrap;
  flex-grow: 0;
  gap: 6px;
  align-items: center;
  width: 100%;
}

.hidden-tags {
  position: relative;

  &:hover {
    .hidden-tags__list {
      opacity: 1;
      pointer-events: auto;
    }
  }
}

.hidden-tags__list {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 100%;
  z-index: var(--z-index-8);
  padding-top: 4px;
  transition: opacity 0.2s ease-in;
}
</style>
